import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './FileItem.module.css'
import { Affix, Button, Card, Divider, Flex, message, Space, Tag } from 'antd'
import classNames from 'classnames'
import { getVideoPlayerAuthRequest } from './MSGZSListApi'
import Aliplayer from 'aliyun-aliplayer'
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css'
import {
  EditOutlined,
  EllipsisOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import videoPlayerIcon from './videoPlayerIcon.svg'

var player
export default function FileItem(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  // const incrementValue = Number(incrementAmount) || 0;
  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    console.log('---------->>aslkdfj')
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  return (
    <Card
      style={{
        width: '22%',
        marginBottom: '20px',
        marginRight: '1.5%',
        marginLeft: '1.5%',
        paddingBottom:40
      }}
      onClick={(e) => {
        props.downLoadFile(props.info)
      }}
      cover={
        <div
          style={{
            position: 'relative',
            width: '100%',
            aspectRatio: '1/1',
            backgroundColor: 'red',
            overflow: 'hidden',
          }}
        >
          <img
            alt="example"
            src={props.info.file_imageurl}
            style={{ cursor: 'pointer', width: '100%', height: '100%',objectFit:'cover' }}
          />
        </div>
      }
      hoverable={true}
    >
      <Card.Meta title={props.info.file_title} />
      <Flex justify="space-between" style={{position:'absolute',bottom:20,width:"calc(100% - 50px)"}}>
        <text style={{ color: '#9da4b1' }}>{props.info.file_size}</text>
        <text style={{ color: '#9da4b1' }}>下载:{props.info.file_downlaod_num}</text>
      </Flex>
    </Card>
  )
}
